import {
  GET_CAMPAIGN_ANALYSIS,
  GET_CAMPAIGN_ANALYSIS_SUCCESS,
  GET_CAMPAIGN_ANALYSIS_ERROR,
  GET_PING_DETAILS,
  GET_PING_DETAILS_SUCCESS,
  GET_PING_DETAILS_ERROR,
  EXPORT_CAMPAIGN_ANALYSIS,
  EXPORT_CAMPAIGN_ANALYSIS_SUCCESS,
  EXPORT_CAMPAIGN_ANALYSIS_ERROR,
} from "./actionTypes"
import {
  handleGetCampaignAnalysis,
  handleGetCampaignAnalysisError,
  handleGetCampaignAnalysisSuccess,
  handleGetPingDetails,
  handleGetPingDetailsError,
  handleGetPingDetailsSuccess,
} from "helpers/campaign_analysis_helper"

const initialState = {
  campaign_analysis: [],
  error: null,
  loading: false,
  export_loading: false,
  last_page_fetched: 0,
  last_fetched_at: null,
  total_number_of_pages: 0,
  has_next_page: false,
  has_lookahead_pages: false,
  active_cache_key: null,
  page_cache: {},
  last_start_date: null,
  last_end_date: null,
  ping_details: {},
  ping_details_loading: false,
  ping_details_error: null
}

const CampaignAnalysis = (state = initialState, action) => {
  switch (action.type) {
    case GET_CAMPAIGN_ANALYSIS:
      return handleGetCampaignAnalysis(state, action)

    case GET_CAMPAIGN_ANALYSIS_SUCCESS:
      return handleGetCampaignAnalysisSuccess(state, action)

    case GET_CAMPAIGN_ANALYSIS_ERROR:
      return handleGetCampaignAnalysisError(state, action)

    case GET_PING_DETAILS:
      return handleGetPingDetails(state)

    case GET_PING_DETAILS_SUCCESS:
      return handleGetPingDetailsSuccess(state, action)

    case GET_PING_DETAILS_ERROR:
      return handleGetPingDetailsError(state, action)

    case EXPORT_CAMPAIGN_ANALYSIS:
      return {
        ...state,
        export_loading: true,
      }

    case EXPORT_CAMPAIGN_ANALYSIS_SUCCESS:
      return {
        ...state,
        export_loading: false,
      }

    case EXPORT_CAMPAIGN_ANALYSIS_ERROR:
      return {
        ...state,
        export_loading: false,
        error: action.payload,
      }

    default:
      return state
  }
}

export default CampaignAnalysis
